import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean;
    heightFeet: number,
    heightInchesRemaining: number,
    heightCm: number,
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmHeight: React.FC<IProps> = ({ show, heightFeet, heightInchesRemaining, heightCm, onConfirm, onCancel }) => {
    return (
        <Modal backdrop='static' show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Donor Height</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='text-center' style={{ marginBottom: 10 }}>
                    You have entered a height of {heightCm} cm / {heightFeet} ft {heightInchesRemaining} in.
                </div>
                <div className='text-center'>
                    Is this correct?
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={onConfirm}>Confirm</Button>{' '}
                <Button onClick={onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmHeight;
